import { COMMENT_MAX_LENGTH, FIELD } from "./constants";

const TABLE = "WMTRANSACTIONHEADER";

/**
 * The single group reproduces the legacy form's left group box (grpBottomMiddle in uWMD0077.dfm), which
 * holds exactly one control: the Comment memo.
 *
 * The right-hand group box ("Additional Information") is NOT a form group — it is a read-only TMemo, so
 * the page renders it beside this panel rather than as a schema group.
 *
 * "type": "textarea" because the Delphi control is a TMemo (Architecture.md rule 9). It is genuinely
 * multi-line in AI8 — the box is four lines tall — and the value goes to @InComment, which the
 * procedure declares as Text.
 *
 * required: false, matching Delphi — the Comment is optional and a run with none is the normal case.
 *
 * isLabelChanged: true so Fields.js uses the literal label instead of a Localization lookup; this
 * caption must match the Delphi form and no localization key exists for it.
 */
const ParametersLayout = [
    {
        groupId: 1,
        // No caption, matching the Delphi: grpBottomMiddle is an untitled group box holding just the
        // Comment memo and its field label. FormField renders <legend> unconditionally
        // (FormField.js:395), so the empty string is paired with a CSS rule in
        // transferShipmentsToDispatch.css that collapses the legend — otherwise the fieldset border
        // keeps the notch the legend would have sat in.
        label: "",
        fields: [
            {
                name: FIELD.Comment,
                tableName: TABLE,
                label: "Comment",
                type: "textarea",
                required: false,
                maxLength: COMMENT_MAX_LENGTH,
                visible: true,
                isLabelChanged: true,
            },
        ],
    },
];

export { ParametersLayout };
